// extracted by mini-css-extract-plugin
export default {"homePageWrapper":"HomePage_homePageWrapper__44qvy","categoryCardWrapper":"HomePage_categoryCardWrapper__aij92"};